import axios from 'axios';
import axiosRetry from 'axios-retry';
import { handleRefreshToken } from './jwt';
import { PATH_AUTH } from 'src/routes/paths';
import { appEnvVariables } from 'src/config';
import { ApiType } from 'src/@types/types';

const axiosInstance = axios.create({
  timeout: 30000,
});

axiosRetry(axiosInstance, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

axiosInstance.interceptors.request.use((config) => {
  config.baseURL = appEnvVariables.api;

  if (config.apiType === ApiType.NEW) {
    config.baseURL = appEnvVariables.newApi;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      originalRequest &&
      !originalRequest.url.endsWith('user/refresh') &&
      error.response &&
      error.response.status === 401 &&
      originalRequest['axios-retry'].retryCount === 0
    ) {
      originalRequest['axios-retry'].retryCount += 1;

      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        await handleRefreshToken({ refreshToken: refreshToken });

        let accessToken = localStorage.getItem('accessToken');

        originalRequest.headers.Authorization = accessToken ? 'Bearer ' + accessToken : '';

        return axiosInstance(originalRequest);
      } else {
        window.location.href = PATH_AUTH.login;
      }
    }

    return Promise.reject((error.response && error.response.data) || error);
  }
);

export default axiosInstance;
